function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M2.06408 0C2.57825 0 3.14215 4.16894 3.76244 7.07691H10.6962C11.141 7.07691 11.5019 7.38492 11.5019 7.76499C11.5019 8.14507 11.141 8.45308 10.6962 8.45308H4.09163C4.32864 9.3058 4.57334 9.85703 4.82637 9.82924C6.81023 9.61112 12.4016 9.22377 12.8831 9.63278C13.3642 10.0416 12.2048 12.5871 12.2048 12.5871H8.04894V14.2523C8.04894 14.2859 8.04291 14.3181 8.03729 14.3507H11.3868C11.7045 14.3507 11.9623 14.5705 11.9623 14.8419C11.9623 15.1135 11.7047 15.3333 11.3868 15.3333H3.09991C2.78217 15.3333 2.52435 15.1135 2.52435 14.8419C2.52435 14.5705 2.78196 14.3507 3.09991 14.3507H6.4492C6.44379 14.3181 6.43755 14.2859 6.43755 14.2523V12.5871H2.51229L0.184885 3.93166C0.184885 3.93166 -0.550894 0.00249167 0.913173 0",
  fill: "#301D31"
});

function SvgSeaticon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 16,
    viewBox: "0 0 13 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeaticon);
export default __webpack_public_path__ + "static/media/seaticon.65709a95.svg";
export { ForwardRef as ReactComponent };